import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { PageHeader } from '../../../Components/Custom/PageHeader';
import { SearchInputFilter } from '../../../Components/Custom/SearchInputFilter';
import { SearchSubmitButton } from '../../../Components/Custom/SearchSubmitButton';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { setDocumentTitle } from '../../../helpers/helpers';
import { getTotalBonus } from './slice';

const PAGE_TITLE = 'Total Bonus';

const TotalBonusPage = () => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { loading, data } = useAppSelector((state) => state.totalBonus);
  const [id, setId] = useState(searchParams.get('id') || '');

  useEffect(() => {
    if (id) {
      dispatch(getTotalBonus(Number(id)));
    }
  }, [searchParams]);

  const { userPackage } = data;

  setDocumentTitle(PAGE_TITLE);
  return (
    <div className='page-content'>
      <Container fluid>
        <BreadCrumb title={PAGE_TITLE} pageTitle='Bonuses' />
        <Row>
          <Col lg={12}>
            <Card id='orderList'>
              <PageHeader loading={loading} title={PAGE_TITLE} />

              <CardBody className='pt-0'>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setSearchParams({ id });
                  }}>
                  <CardBody className='border border-dashed border-end-0 border-start-0'>
                    <Row>
                      <Col md={3} sm={4}>
                        <SearchInputFilter
                          onChange={(e: any) => setId(e.target.value)}
                          value={id}
                          placeholder='Search User Package ID'
                        />
                      </Col>
                      <Col md={3} sm={4}>
                        <SearchSubmitButton />
                      </Col>
                    </Row>
                  </CardBody>
                  {userPackage && (
                    <CardBody className='border border-dashed border-end-0 border-start-0'>
                      <Row>
                        <Col md={2} sm={4}>
                          Order ID: {userPackage.id}
                        </Col>
                        <Col md={2} sm={4}>
                          Order Date:{' '}
                          {moment(userPackage.dateCreated).format('DD.MM.YYYY')}
                        </Col>
                        <Col md={2} sm={4}>
                          Order User ID: {userPackage.userId}
                        </Col>
                        <Col md={2} sm={4}>
                          Order Value: {userPackage.price}
                        </Col>
                        <Col md={4} sm={4}>
                          Order Paid amount: {userPackage.paidAmount}
                        </Col>
                      </Row>
                    </CardBody>
                  )}
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TotalBonusPage;
